import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';

import EventThings from 'app/src/components/Events/EventThings';
import EventTypes from 'app/src/components/EventTypes/Select';
import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { LIBRARY, UPDATE_LIBRARY } from './queries';
import { FIELDS } from './new';

const Library = () => {
  const { id } = useParams();
  const [libraryEventTypes, setLibraryEventTypes] = useState({});
  const [libraryThings, setLibraryThings] = useState({});
  const navigate = useNavigate();

  const {
    control, handleSubmit, reset, watch, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(LIBRARY, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.library }));

      const libraryEventTypesData = {};
      data.library.eventTypes.forEach(eventType => {
        libraryEventTypesData[eventType.id] =
          { eventTypeId: eventType.id, selected: true };
      });

      setLibraryEventTypes(libraryEventTypesData);

      const libraryThingsData = {};
      data.library.things.forEach(thing => {
        libraryThingsData[thing.id] = { thingId: thing.id, selected: true };
      });

      setLibraryThings(libraryThingsData);
    }
  }, [data]);

  const { submit: updateLibrary, formStatus, errorMessage } =
    useFormSubmit(UPDATE_LIBRARY, {
      onCompleted: () => navigate('/libraries'),
    });

  const onSubmit = input => {
    input.libraryThingsAttributes = Object.keys(libraryThings)
      .map(thingId => libraryThings[thingId])
      .filter(libraryThing => libraryThing.selected)
      .map(libraryThing => ({ thingId: libraryThing.thingId }));

    input.libraryEventTypesAttributes = Object.keys(libraryEventTypes)
      .map(eventTypeId => libraryEventTypes[eventTypeId])
      .filter(libraryEventType => libraryEventType.selected)
      .map(libraryEventType => ({ eventTypeId: libraryEventType.eventTypeId }));

    updateLibrary({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>{data?.library.name}</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}

      <EventTypes
        selected={libraryEventTypes}
        setSelected={setLibraryEventTypes}
      />

      <EventThings
        eventThings={libraryThings}
        setEventThings={setLibraryThings}
        watch={watch}
        showAllButtons
        noNotes
      />
    </View>
  );
};

export default Library;
